/* eslint-disable camelcase */
import {
  createRequestContract,
  createResponseContract,
  createSpec,

  requestVerbs,
  responseTypes,
  specTypes,
} from '@bingads-webui-react/overreact';

import { composeSearchString } from '@bingads-webui-react/overreact-odata';

import { edm } from '../../../../../env/edm';
import { environmentLookupFn } from '../../../../../env/env-instance';
import { schema } from '../../../../../env/schema';

import {
  urlDecorator,
  headerDecorator,
  payloadDecorator,
  processorDecorator,
  keySelectorDecorator,
  sideEffects,

  networkPolicy,
} from './mutation-decorators';

function odataUrlFactory(params) {
  const { variables } = params;
  const { locator: { descriptor } } = variables;
  const {
    customer_id,
  } = descriptor;

  const edmEntity = edm
    .Customers.$withKey(customer_id)
    .Accounts;

  const searchString = composeSearchString(variables, edmEntity, false);
  return `${edmEntity.path}${searchString}`;
}

function odataHeaderFactory(params) {
  return params.headers;
}

function odataPayloadFactory(params) {
  return params.data;
}

const requestContract = createRequestContract({
  schema,
  dataPath: 'customer:account',
  verb: requestVerbs.PATCH,
  fetchPolicy: networkPolicy,
  uriFactoryFn: urlDecorator(odataUrlFactory),
  headerFactoryFn: headerDecorator(odataHeaderFactory),
  payloadFactoryFn: payloadDecorator(odataPayloadFactory),
  keySelector: variables => variables.locator.descriptor.account_id,
  parentKeySelector: variables => variables.locator.descriptor.customer_id,
});

const responseContract = createResponseContract({
  requestContract,
  responseType: responseTypes.COLL,
  keySelector: keySelectorDecorator(r => r.Id),
  processorFn: processorDecorator(r => r.value),
});

export const mutationSpec = createSpec(
  requestContract,
  responseContract,
  specTypes.MUTATION,
  sideEffects.mutation,
  environmentLookupFn
);
